import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../../../common/models/api-response.model';
import { ENDPOINTS } from '../../../../../common/constants/endpoints.constants';
import { SequentialWfItem } from '../../../../../common/models/sequential-request.model';

@Injectable({
  providedIn: 'root',
})
export class SequentialRequestService {
  private readonly http = inject(HttpClient);
  private readonly endpoints = ENDPOINTS;

  getSequentialWf(
    perPage = 50,
    page = 1,
    containerId?: number
  ): Observable<ApiResponse<SequentialWfItem>> {
    const params = new HttpParams()
      .set('per_page', perPage)
      .set('page', page)
      .set('filters[container_id]', containerId ?? '');

    return this.http.get<ApiResponse<SequentialWfItem>>(
      this.endpoints.Application.Organization.SequentialFlowTree,
      { params }
    );
  }

  getSequentialWfDetails(
    perPage = 50,
    page = 1,
    containerId?: number
  ): Observable<ApiResponse<SequentialWfItem>> {
    const params = new HttpParams()
      .set('per_page', perPage)
      .set('page', page)
      .set('filters[container_id]', containerId ?? '');

    return this.http.get<ApiResponse<SequentialWfItem>>(
      this.endpoints.Application.Organization.SequentialFlowTemplateTree,
      { params }
    );
  }
}
